import {Component, Mixins, Vue, Watch} from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { getCustomerConversionById, getLeaderDepartmentByUserId, duplicateCheck, setCustomerConversionById, checkCustomerConversionFollow } from '@/api/customer'
import { setSchool, getSchoolList } from '@/api/common'
import { Form, File } from './interface'
import ElSelectSchool from '@/components/el-select-school/index.vue'
import data from './data'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

Vue.directive('el-select-loadmore3', { // 指令懒加载
    // bind表示这个自定义指令一绑定到dom上，就开始自动执行
    bind(el: any, binding: any) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
            /**
            * scrollHeight 获取元素内容高度(只读)
            * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
            * clientHeight 读取元素的可见高度(只读)
            * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
            * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
            */
            const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
            if (condition) {
                binding.value();
            }
        });
    },
    // 表示dom插入到页面上的时候自动执行
    // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
    inserted(el, binding) {
      el.focus()
    },
    // 表示自定义指令后面的值更新的时候，自动执行
    update() {
        // console.log(this.scrollHeight , this.scrollTop, '11');
    }
  })

@Component({
    components: { ElSelectSchool , MoreUsersFilter}
})
export default class EditCustormerInfo extends Mixins(data) {
    // data
    pageSchool = 1
    addDialog = false  //添加学校
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    repeatName: any =null

    saveButtonDisabled = false
    dialogTable1 = false
    dialogTable2 = false
    dialogTable3 = false
    dialog2 = false
    dialogConserve = false
    dialogTableData1 = []
    dialogTableData2 = []
    dialogTableData3 = []
    fileList: File[] = []
    formData: Form = {
        realName: '', // 真实姓名
        gender: '', // 性别
        phone: '', // 手机号
        email: '', // 邮箱
        weChat: '', // 学生微信
        attendSchool: '', // 就读学校
        schoolId: null, //学校id
        grade: '', //当前年级
        specialized: '', // 所学专业
        targetSpecialized: '', //目标专业
        remark: '', // 备注
        eduTemandList: [],
        parentName: '', // 家长姓名
        parentPhone: '', // 家长手机号
        parentWeChat: '', // 家长微信
        targetSchool: '', // 学员目标学校
        achievement: '', // 语言成绩
        feedback: '', // 笔试反馈

        // activeConsultation: '', // 是否主动咨询科研项目
        informationList: [], // 相关资料
        directorUserId: '', // 第一负责人id
        leaderUserRealName: '', // 主管name
        leaderUserId: '', // 主管id
        customerConversionShareList: [] ,// 共享user数组
        // ipqSubject: '', // ipq学科方向 2023-12-6移除
        region: '', // 所在城市

        productRequirementList: [],
        attendSchoolType: '',
    }
    createdUserRealName: ''  //客户接收人
    formRules = {}
    id: number;
    page=1
    allPage=null
    gradeList = [
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）',
        '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业',
        '待定',
        '7年级以下'
    ]
    IPQList = [
        '金融/金融工程',
        '经济学',
        '市场营销 （广告学，奢侈品管理）',
        'PPE（政经哲）',
        '酒店管理/旅游管理',
        '管理学',
        '人力资源管理',
        '体育管理',
        '会计学',
        '行为经济学',
        '心理学（教育心理，犯罪心理，体育心理）',
        '教育',
        '法学',
        '传媒（新闻，传播，文化传媒）',
        '历史',
        '国际关系',
        '性别研究',
        '社会学',
        '哲学（伦理学，逻辑学）',
        '公共政策管理',
        '语言学',
        '文学',
        '人类学/考古学',
        '建筑/电影/音乐/视觉艺术',
        '计算机（计算机科学，计算机工程）',
        '机械工程（流体力学）',
        '电子工程',
        '物理',
        '天文学',
        '应用数学（数据科学）',
        '数学',
        '生物（药学，医学，营养学，生物化学）',
        '公共卫生（生物统计）',
        '化学',
        '环境工程/环境科学',
        '土木工程',
        '地理/地质'
    ]
    eduTemandOptions = ['留学', '高考', '考研', '保研', '考博', '无升学需求', '待定', '国内求职', '海外求职']
    schoolList: any = []
    scrollHeight: any = null
    scrollTop: any = null
    clientHeight: any =null
    name: any =null
    repeatStudentName: any = false
    repeatStudentWeixin: any = false
    repeatStudentIphone: any = false
    previewVisible = false
    previewPath = ''
    previewName = ''
    informationListImg = []
    regionName = '' // 当地域选择为【其他】的时候 使用

    oldShareUserIdList=[]

    isEdit = '0'  // 是编辑还是详情 -- 默认为详情
    culesInfoShow = false
    infoData: any = ''

    customerInfoShow = true
    menuBtn = menuBtn
    // 跟进记录
    tableData = []
    loading = false
    activities = []
    operationShow = true
    formatDate = formatDate
    directorUserName = ''
    customerConversionShareList = []
    attendSchoolTypeList = [
        {label: '海外院校', value: '0'},
        {label: '国内院校', value: '1'},
        {label: '国际高中', value: '2'},
        {label: '普高', value: '3'},
        {label: '其他', value: '4'},
    ]
    schoolLoading = false
    productRequirementList = [
        {label: '科研', value: '科研'},
        {label: '竞赛', value: '竞赛'},
        {label: '实习', value: '实习'},
        {label: '实训', value: '实训'},
        {label: '全职', value: '全职'},
        {label: '其他', value: '其他'}
    ]
    // created()

    created() {
        this.formRules = {
            realName: [
                {required: true, message: '请输入真实姓名', trigger: ['blur', 'change']},
                {validator: this.realNameChecking, trigger: ['blur', 'change']}
            ],
            grade: [{ required: true, message: '请选择当前年级', trigger: 'change' }],
            eduTemandList: [{ required: true, message: '请选择升学需求', trigger: 'change' }],
            // activeConsultation: [{ required: true, message: '请选择是否报价', trigger: 'change' }],
            phone: [
                { validator: this.phoneChecking, trigger: 'change' }
            ],
            weChat: [
                { validator: this.weChatChecking, trigger: 'change' }
            ],
            targetSpecialized:[{ required: true, message: '请输入目标专业', trigger: ['blur', 'change'] }],
            specialized:[{ required: true, message: '请输入当前专业/课程体系', trigger: ['blur', 'change'] }],
            // ipqSubject:[{ required: true, message: '请选择IPQ学科方向', trigger: ['blur', 'change'] }], // ipq学科方向x
            region:[{ required: true, message: '请选择所在城市', trigger: ['blur', 'change'] }], // 所在城市
            attendSchool:[{ required: true, message: '请输入就读学校', trigger:  ['blur', 'change'] }], // 就读学校

            attendSchoolType:[{ required: true, message: '请选择就读学校类别', trigger:  ['blur', 'change'] }], // 就读学校类别
            productRequirementList:[{ required: true, message: '请选择产品需求', trigger:  ['blur', 'change'] }], // 产品需求
        }
        const query = this.$route.query
        this.id = Number(query.id)
        this.isEdit = String(query.isEdit)

        if(this.id) {
            this.getCustomerConversionById()
        }
        if (this.isEdit == '1') {
            this.getSchoolList()
        }
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    lookRrepeat(type: any) {
        if (type === 0) {
            this.dialogTable1 = true
        } if (type === 1) {
            this.dialogTable2 = true
        }
        if (type === 2) {
            this.dialogTable3 = true
        }

    }

    // mounted
    mounted() {
        this.$nextTick(() => {
            const htmls = document.getElementsByClassName('el-form-item')
            for (let i = 0; i < htmls.length; i++) {
                htmls[i].addEventListener('click', (e) => {
                    const dom = e.target as HTMLElement
                    // if (['该名称已存在，详情点击', '该微信已存在，详情点击', '该手机号已存在，详情点击'].indexOf(dom.innerText) !== -1) {
                    //     this.dialog = true
                    // }
                    // if(dom.innerText === '该名称已存在，详情点击') this.dialogTable1 = true
                    // if(dom.innerText === '该微信已存在，详情点击') this.dialogTable2 = true
                    // if(dom.innerText === '该手机号已存在，详情点击') this.dialogTable3 = true
                })
            }
        })
    }

    // computed

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    // methods
    clickEditBtn() {
        // this.$router.push('transfromCustomerEdit?id=' + this.id+'&isEdit=1')
        this.isEdit = '1'

        this.$forceUpdate()
    }
    clickFllowBtn() {
        checkCustomerConversionFollow({id: String(this.id)}).then((res:any) => {
            this.$router.push({
                path: '/customer/transfromCustomerFollow',
                query: {
                    id: String(this.id),
                    name: this.infoData.realName ? this.infoData.realName : this.infoData.marketClue.name,
                    haveFinanceContract: res.haveFinanceContract
                }
            })
        }).catch(error => {
            this.$message.error(error)
        })
    }

    /*
    * 获取转化客户的详细信息
    */
    async getCustomerConversionById() {
        this.loading = true
        await getCustomerConversionById(this.id).then((data: any)=>{
        this.infoData = JSON.parse(JSON.stringify(data.customerConversion))
        //    审批流程
        this.activities = data.customerConversion.messageReviewList
        this.tableData = data.customerConversion.customerConversionFollowList
        const {region, realName, createdUserRealName, gender, phone, email, weChat, attendSchool,
            schoolId, grade, specialized, targetSpecialized, remark, parentName, parentPhone, parentWeChat, targetSchool,
            achievement, feedback, informationList, directorUserId, leaderUserRealName,
            leaderUserId, customerConversionShareList, eduTemandList,directorUserRealName , productRequirementList,attendSchoolType} = data.customerConversion
        this.formData.realName = realName ? realName : ''
        this.formData.region = region ? region : ''
        this.formData.gender = gender
        this.formData.phone = phone ? phone : ''
        this.formData.email = email ? email : ''
        this.formData.weChat = weChat ? weChat : ''
        this.formData.attendSchool = attendSchool ? attendSchool : ''
        this.formData.schoolId = schoolId ? schoolId: ''
        this.formData.grade = grade ? grade : ''
        this.formData.specialized = specialized ? specialized : ''
        this.formData.targetSpecialized = targetSpecialized ? targetSpecialized : ''
        this.formData.remark = remark ? remark : ''
        this.formData.eduTemandList = eduTemandList ? eduTemandList : []
        this.formData.parentName = parentName ? parentName : ''
        this.formData.parentPhone = parentPhone ? parentPhone : ''
        this.formData.parentWeChat = parentWeChat ? parentWeChat : ''
        this.formData.targetSchool = targetSchool ? targetSchool : ''
        this.formData.achievement = achievement ? achievement : ''
        this.formData.feedback = feedback ? feedback : ''
        // this.formData.activeConsultation = activeConsultation ? activeConsultation : ''
        this.formData.directorUserId = directorUserId ? directorUserId : ''
        this.formData.leaderUserRealName = leaderUserRealName ? leaderUserRealName : ''
        this.createdUserRealName = createdUserRealName ? createdUserRealName : ''
        this.formData.leaderUserId = leaderUserId ? leaderUserId : ''
        this.formData.customerConversionShareList = customerConversionShareList.map((item: { realName: string; userId: string }) => item.userId)
        this.oldShareUserIdList=this.formData.customerConversionShareList

        this.directorUserName = directorUserRealName? directorUserRealName : ''
        this.formData.productRequirementList = productRequirementList ? productRequirementList : []
        this.formData.attendSchoolType = attendSchoolType ? attendSchoolType : ''


        this.customerConversionShareList = []
        customerConversionShareList.forEach((item: any) => {
            this.customerConversionShareList.push({
                id: item.userId,
                realName: item.realName,
            })
        })

        // this.fileList = informationList.map((item: string, index: number) => ({ name: '', url: item }))
        const list = informationList.length ? JSON.parse(JSON.stringify(informationList)):[]
        // this.formData.ipqSubject = ipqSubject ? ipqSubject : '' // 2023-12-6移除
        const list1 = []
        list.forEach((item: any)=>{
            if(item) {
                const url = decodeURI(item)
                const str = url.split('/crm/')[1];
                if(this.fileExtension(item)==='png'|| this.fileExtension(item.url)=='PNG'|| this.fileExtension(item.url)=='JPG' || this.fileExtension(item)==='jpg' || this.fileExtension(item.url)=='JPEG'|| this.fileExtension(item)==='jpeg'){
                    this.informationListImg.push(item)
                }
                if(str) {
                    const name = str.slice(20);
                    const obj = {name: name, url: item}
                    list1.push(obj)
                }
            }
        })
        this.fileList = list1
        this.loading = false
        }).catch((err: any) => {
            this.loading = false
        })
    }

    handleBlur(){
        const reg1 = /^[·\s]/  // 头部有空格和·
        const reg2 = /[·\s>]$/  // 尾部有空格和·
        const reg3 = /^[\u4e00-\u9fa5\uf900-\ufaff\u3400-\u4dbfa-zA-Z·\s]+$/

        if (reg1.test(this.formData.realName) || reg2.test(this.formData.realName) || !reg3.test(this.formData.realName)) {
            this.$message.error('真实姓名，只允许字母和汉字和·,前后不可有空格')
            return
        }
    }

    /*
    * 编辑保存转化客户
    */
    setCustomerConversionById() {
        const {region, realName, gender, phone, email, weChat, attendSchool, schoolId, grade, specialized, targetSpecialized, remark, parentName, parentPhone, parentWeChat, targetSchool, achievement, feedback, informationList, directorUserId, customerConversionShareList, eduTemandList, attendSchoolType, productRequirementList } = this.formData

        if (region === '其他' && !this.regionName) {
            this.$message.error('所在城市不可为空')
            return false;
        }
        const obj = {
            id: this.id,
            realName,
            gender,
            phone,
            email,
            weChat,
            attendSchool,
            schoolId,
            grade,
            specialized,
            targetSpecialized,
            remark,
            eduTemandList,
            parentName,
            parentPhone,
            parentWeChat,
            targetSchool,
            achievement,
            feedback,

            informationList,
            directorUserId,
            customerConversionShareList,
            attendSchoolType,
            productRequirementList,
            region: region === '其他' ? this.regionName : region,
            shareUserIdList:[],
            delShareUserIdList:[],



        }
        if(schoolId === '' || schoolId === null || schoolId === undefined){
            obj.schoolId = null
        }

        obj.shareUserIdList=obj.customerConversionShareList.filter(c=>this.oldShareUserIdList.indexOf(c)==-1)
        obj.delShareUserIdList=this.oldShareUserIdList.filter(c=>obj.customerConversionShareList.indexOf(c)==-1)

        // (this.$refs['rulesForm'] as HTMLFormElement).validate(valid => {
        //     if(valid){
        this.saveButtonDisabled = true
        this.loading = true
        setCustomerConversionById(obj)
            .then(() => {
                this.$message.success('保存成功')
                this.loading = false
                setTimeout(() => {
                    window.close()
                }, 1500)
            })
            .catch(() => {
                this.saveButtonDisabled = false
                this.loading = false
            })
        //     }
        // })
    }

    /*
    * 获取第一负责人的主管
    */
    async changedirectorUser(id: string) {
        const data: any = await getLeaderDepartmentByUserId(id)
        this.formData.leaderUserId = data.userId
        this.formData.leaderUserRealName = data.userRealName
    }

    changeDirectorUsers(e) {
        this.formData.directorUserId = e.id
        if (e.id) {
            this.changedirectorUser(String(this.formData.directorUserId))
        } else {
            this.formData.leaderUserId = ''
            this.formData.leaderUserRealName = ''
        }
    }

    changeCustomerConversionShareList(e) {
        this.formData.customerConversionShareList = e.id
    }

     /*
    * 就读学校添加学校
    */
    handleAdd(){
        this.formData.attendSchool = ''
        this.formData.schoolId = null
        this.addDialog = true
    }
    async getSchoolList() {
        this.schoolLoading = true
        await getSchoolList({page: this.page,  name: this.name}).then((data: any)=>{
        this.schoolList = [...this.schoolList, ...data.schoolList]
        const result = []
        const obj = {}
        for(let i =0; i<this.schoolList.length; i++){
            if(!obj[this.schoolList[i].id]){
                result.push(this.schoolList[i]);
                obj[this.schoolList[i].id] = true;
            }
        }
        this.schoolList = result
            this.schoolLoading = false
        }).catch(err=>{
            this.schoolLoading = false
        })
    }
    // async confirmSchool() {
    //     await setSchool({name: this.schoolName, types: this.schoolType})
    //         this.$message.success('新建学校成功')
    //         this.formData.attendSchool = this.schoolName
    //         const result: any = await getSchoolList({page: this.pageSchool,  name: this.schoolName })
    //         const schoolItem = result.schoolList.filter(item => item.name === this.schoolName)[0]
    //         this.formData.schoolId = schoolItem.id
    //         this.schoolList = result.schoolList
    //         this.schoolName = ''
    //         this.schoolType = ''
    //         this.addDialog = false
    // }

    /*
    * 关于上传相关资料的函数
    */
    handleUploadError() {
        this.$message.error('上传失败')
    }
    handleUploadSuccess(res: any, file: File, fileList: File[]) {
        if (res.error.returnCode === 0) {
            this.fileList.push({ name: res.data.name, url: res.data.ossUrl })
            this.$message.success('上传成功')
        } else {
            this.$message.error(res.error.returnUserMessage)
        }
    }
    handleRemoveFile(file: File, fileList: File[]) {
        this.$message.success('删除文件')
        this.fileList = fileList.map((item: File) => ({ name: item.name, url: item.url }))
    }
    beforeUpload(file, fileList) {
        if (file.size / (1024 * 1024) > 50) {  // 限制文件大小
          this.$message.warning(`当前限制文件大小不能大于50M`)
          return false
        }
    }
    /*
    * 【真实姓名】查重验证函数
    */
    async realNameChecking(rule: any, value: string, callback: any) {
        if(!value) {
            callback(new Error('请填写真实姓名'))
            return
        }
        const data: any = await duplicateCheck({ id: this.id, types: 0, values: value })
        this.dialogTableData1 = [...data.result]
        if (data.result.length > 0) {
            this.dialogConserve = true
            this.repeatStudentName = true
            // callback(new Error('该名称已存在，详情点击'))
        } else {
            callback()
            this.dialogConserve = false
            this.repeatStudentName = false
        }
    }
    // 【学生微信】查重验证
    async weChatChecking(rule: any, value: string, callback: any) {
        if (!value) {
            callback()
            return
        }
        const data: any = await duplicateCheck({ id: this.id, types: 1, values: value })
        this.dialogTableData2 = [...data.result]
        if (data.result.length > 0) {
            this.dialogConserve = true
            this.repeatStudentWeixin = true
            // callback(new Error('该微信已存在，详情点击'))
        } else {
            callback()
            this.dialogConserve = false
            this.repeatStudentWeixin = false
        }
    }
    // 【手机号】查重验证
    async phoneChecking(rule: any, value: string, callback: any) {
        if(!value) {
            callback()
            return
        }
        const data: any = await duplicateCheck({ id: this.id, types: 2, values: value })
        this.dialogTableData3 = [...data.result]
        if (data.result.length > 0) {
            this.dialogConserve = true
            this.repeatStudentIphone = true
            // callback(new Error('该手机号已存在，详情点击'))
        } else {
            callback()
            this.dialogConserve = false
            this.repeatStudentIphone = false
        }
    }

    clickConserve() {
        // if(!this.formData.realName) { this.$message.error('请填写真实姓名'); return }
        // if(this.formData.eduTemandList.length == 0) { this.$message.error('请选择升学需求'); return }
        // if(!this.formData.grade) { this.$message.error('请选择当前年级'); return }
        // if(!this.formData.overseasStudy) { this.$message.error('请选择是否留学'); return }
        // if(!this.formData.activeConsultation) { this.$message.error('请选择是否主动咨询科研项目'); return }

        if (this.dialogTableData1.length > 0 || this.dialogTableData2.length > 0 || this.dialogTableData3.length > 0 ) {
            this.dialog2 = true
        } else {

            (this.$refs.rulesForm as HTMLFormElement).validate((valid: boolean) => {
                if (valid) {
                    const reg1 = /^[·\s]/  // 头部有空格和·
                    const reg2 = /[·\s>]$/  // 尾部有空格和·
                    const reg3 = /^[\u4e00-\u9fa5\uf900-\ufaff\u3400-\u4dbfa-zA-Z·\s]+$/

                    if (reg1.test(this.formData.realName) || reg2.test(this.formData.realName) || !reg3.test(this.formData.realName)) {
                        this.$message.error('真实姓名，只允许字母和汉字和·,前后不可有空格')
                        return
                    }
                    this.setCustomerConversionById()
                }
            })

        }
    }

    closeDialog2() {
        this.dialog2 = false
    }
    clearSchool() {
        this.formData.schoolId = null
        this.formData.attendSchool = ''
        this.name = null
        this.page = 1
        this.getSchoolList()
    }

    loadmore() {
        this.page++
        this.getSchoolList();
    }
    async remoteMethod (query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getSchoolList({page: this.page,  name: query })
            this.schoolList = result.schoolList
        } else {
        //   this.schoolList = []
        }
    }
    handleSchoolBlur(e){
        if(!this.formData.schoolId){
            this.name = null
            this.page = null
            this.getSchoolList()
        }
    }
    async handleSchool(){
        this.schoolLoading = true
        if((this.schoolList.length == 0 || !this.name) && !this.formData.attendSchool){
            this.name = null
            this.page = 1
            const result: any = await getSchoolList({page: this.page,  name: this.name })
            this.schoolList = result.schoolList
            this.schoolLoading = false
        }
        if(this.formData.attendSchool){
            this.schoolList = []
            this.page = 1
            // const result: any = await getSchoolList({page: this.page,  name: this.name })
            const result: any = await getSchoolList({page: this.page,  name: this.formData.attendSchool })
            this.schoolList = result.schoolList
            this.schoolLoading = false
        }
    }
    // 选择学校
    changeSchool (val) {
        if(val) {
            this.formData.attendSchool = val
            this.formData.schoolId = this.schoolList.find(item=> item.name === this.formData.attendSchool).id
        }
    }
    @Watch('fileList', { deep: true })
    handleWatchFileList(newValue: File[]) {
        this.formData.informationList = newValue.map((item: File) => item.url)
    }
}
